import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

import { AvaHours } from '@models';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  tradingDays: AvaHours[];
  isEcommClosed: boolean;
};

const TradingHoursModals: FC<Props> = ({ isOpen, tradingDays, onClose, isEcommClosed }) => {
  const theme = useTheme();
  return (
    <Dialog open={isOpen} data-testid="trading-closing-hours-modal">
      <DialogTitle>
        {isEcommClosed ? (
          <Typography data-testid="closed-hours-text" color="darkred">
            Trading hours are closed for this suburb
          </Typography>
        ) : (
          <Typography data-testid="open-hours-text">Trading hours</Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Day</TableCell>
                <TableCell>Open</TableCell>
                <TableCell>Close</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tradingDays.map((tday, index) => (
                <TableRow
                  key={`${tday.day}-${new Date().getTime()}`}
                  style={{
                    background: new Date().toLocaleString('en-us', { weekday: 'long' }) === tday.day ? theme.palette.grey[100] : undefined,
                  }}
                >
                  <TableCell>{tday.day}</TableCell>
                  <TableCell>{tday.open}</TableCell>
                  <TableCell>{tday.closed}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TradingHoursModals;
